<template>
  <v-app>
    <v-app-bar app dark class="white">
      <img
        src="../src/assets/colourspectrums-logo.svg"
        height="100%"
      /><v-spacer></v-spacer>
        <Menu/>
    </v-app-bar>
    <v-main class="light-blue lighten-5">
      <router-view />
    </v-main>
    <v-footer padless>
      <v-row justify="center" align="center">
        © 2019 - {{ new Date().getFullYear() }} -
        <div style="width: 0.5em;"></div>
        <a
          href="https://www.colourspectrums.com/contact"
          target="_blank"
          title="Contact ColourSpectrums!"
          ><img src="./assets/colourspectrums-logo.svg" height="50px"
        /></a>
        <span style="width: 30px"></span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Menu from "./components/Menu";
export default {
  title: "ColourSpectrums Dashboard",
  name: "App",
  components: { Menu },
  data: () => ({
    loggedIn: false,
  }),
};
</script>

<style></style>
